const STORAGE_KEY = "vammo_device_fingerprint";

// Module-scoped fallback so the value stays stable across calls within the
// same page session when localStorage is unavailable (Safari Private, ITP,
// iOS in-app browsers). Without this, send/verify would see different
// fingerprints and the device-bound OTP check would always fail.
let inMemoryFingerprint: string | null = null;

const generate = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for very old browsers — non-crypto random is acceptable here
  // because the value is only used to bind an OTP challenge to a device.
  return `df_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
};

export const getDeviceFingerprint = (): string => {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) {
      inMemoryFingerprint = existing;
      return existing;
    }

    const value = generate();
    localStorage.setItem(STORAGE_KEY, value);
    inMemoryFingerprint = value;
    return value;
  } catch {
    if (!inMemoryFingerprint) {
      inMemoryFingerprint = generate();
    }
    return inMemoryFingerprint;
  }
};
